function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M42.99 21.93l10.81 1.56c3.06.44 4.29 4.2 2.07 6.37l-7.81 7.64c-.88.86-1.28 2.1-1.08 3.31l1.85 10.76c.53 3.05-2.68 5.39-5.42 3.95l-9.65-5.09a3.755 3.755 0 00-3.48 0l-9.65 5.09c-2.74 1.45-5.95-.88-5.43-3.93l1.83-10.76c.21-1.22-.2-2.45-1.08-3.3l-7.82-7.61c-2.22-2.16-1-5.92 2.06-6.37L21 21.97c1.22-.18 2.27-.94 2.81-2.05l4.82-9.8c1.37-2.78 5.33-2.79 6.7-.01l4.85 9.79a3.682 3.682 0 002.81 2.04z",
  fill: "currentColor"
})));